<template>
<div class="scheme-content">
  <div class="banner">
    <div class="title">产品及方案中心</div>
    <div class="info"> 依托AIoT技术，与山大岩土团队为隧道 / 道桥 / 矿山等工程提供全周期智能监测方案。</div>
  </div>
   <div class="scheme-list">
     <el-row :gutter="22">
       <el-col :sm="12" :xs="24" :md="8">
         <div class="item" @click="$router.push('/ExplorationVehicle')">
           <div class="sub-title">HURI虎锐</div>
           <div class="title">隧道无人巡检机器人</div>
           <div class="info">多功能无人巡检、拖曳、运输</div>
           <div class="link" >了解更多 <i class="el-icon-arrow-right"></i></div>
           <img src="/static/img1.png" alt="">
         </div>
       </el-col>
       <el-col :sm="12" :xs="24" :md="8" v-for="(item, index) in schemeList" :key="index">
         <div class="item" @click="goToInfo(item)">
           <div class="title">{{ item.title }}</div>
           <div class="info">{{ item.info.slice(0,50) }}···</div>
           <div class="link" >了解更多 <i class="el-icon-arrow-right"></i></div>
           <el-image  :src="item.url" lazy></el-image>
         </div>
       </el-col>
     </el-row>
   </div>
  <footerView></footerView>
</div>
</template>

<script>
import footerView from "@/components/footerView.vue";
export default {
  name: "SchemeView",
  components:{
    footerView
  },
  data(){
    return {
      schemeList:[
        {
          title:'隧道衬砌病害动态识别方法',
          info:'为全面提升隧道衬砌病害识别能力，本方案采用自主研发的隧道衬砌病害智能检测算法系统，基于深度学习和计算机视觉技术，构建集病害识别、定位、量化分析于一体的智能检测平台，实现隧道衬砌病害的自动化精准诊断。',
          url:'/static/img2.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）基于改进的病害识别算法，支持裂缝、渗漏水、剥落等8类典型病害的智能识别</div>" +
              " <div class='content-item'>（二）多尺度特征融合技术，实现细微病害的高精度检测</div>" +
              " <div class='content-item'>（三）病害三维定位系统，空间定位精度达±5cm</div>" +
              " <div class='content-item'>（四）病害程度智能评估模块，输出5级损伤评价</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）采用先进的深度学习算法，识别精度高</div>" +
              " <div class='content-item'>（二）具备实时处理能力，检测效率显著提升</div>" +
              " <div class='content-item'>（三）自适应环境变化，在各种工况下保持稳定性能</div>" +
              " <div class='content-item'>（四）系统智能化程度高，大幅降低人工干预</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm1.png' alt=''></div>"
        },
        {
          title:'隧道衬砌病害检测算法',
          info:'为实现隧道衬砌几何形态的精准测量，本方案采用自主研发的隧道衬砌几何检测算法系统，基于三维点云处理和特征匹配技术，构建高精度的隧道几何形态检测平台。',
          url:'/static/img3.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）改进ICP点云配准算法，配准精度达2mm</div>" +
              " <div class='content-item'>（二）断面收敛自动分析模块，支持200+测线同步计算</div>" +
              " <div class='content-item'>（三）三维变形可视化系统，变形趋势预测准确率>90%</div>" +
              " <div class='content-item'>（四）自动报告生成功能，一键输出10+项关键指标</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）测量精度达到行业领先水平</div>" +
              " <div class='content-item'>（二）处理速度快，满足工程检测需求</div>" +
              " <div class='content-item'>（三）支持多种标准断面比对</div>" +
              " <div class='content-item'>（四）操作简便，自动化程度高</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm2.png' alt=''></div>"
        },
        {
          title:'隧道衬砌几何检测算法',
          info:'为提升结构病害识别的智能化水平，本方案采用基于机器视觉的结构病害智能识别系统，结合多模态数据融合和深度学习技术，构建全方位的结构健康诊断平台。',
          url:'/static/img4.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）多模态特征融合网络，支持可见光、红外等4类图像数据处理</div>" +
              " <div class='content-item'>（二）自适应环境算法，确保复杂光照条件下的稳定识别</div>" +
              " <div class='content-item'>（三）病害程度智能评估系统，输出科学维修建议</div>" +
              " <div class='content-item'>（四）维修优先级自动排序功能，基于多维度综合分析</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）支持多种病害类型的精确识别</div>" +
              " <div class='content-item'>（二）综合识别准确率高</div>" +
              " <div class='content-item'>（三）部署方式灵活多样</div>" +
              " <div class='content-item'>（四）具备持续学习升级能力</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm3.png' alt=''></div>"
        },
        {
          title:'桥梁检测方案',
          info:'为提升桥梁结构健康监测的效率和精度，本方案采用无人机智能巡检技术，结合人工智能（AI）图像识别与三维建模，实现对桥梁表观病害的高精度检测与自动化分析，大幅降低人工巡检的安全风险与成本，为桥梁养护决策提供科学依据。  ',
          url:'/static/img5.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）全自动无人机巡检：搭载高分辨率可见光相机,无人机可按照预设航线对桥梁梁体、桥墩、支座、伸缩缝等关键部位进行全方位扫描，获取高清影像与三维点云数据，确保检测无死角。</div>" +
              " <div class='content-item'>（二）AI智能病害识别：基于深度学习算法，系统可自动识别裂缝、剥落、锈蚀、渗水等典型病害，并量化其长度、宽度、面积等参数，生成病害分布热力图，显著提升检测效率与准确性。</div>" +
              " <div class='content-item'>（三）三维数字化建模：通过多视角摄影测量技术，构建桥梁高精度三维实景模型，结合历史数据进行对比分析，监测病害发展趋势，评估结构劣化程度。  </div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）安全高效：避免高空人工作业风险，单次飞行即可完成全桥检测。</div>" +
              " <div class='content-item'>（二）数据可追溯：建立桥梁数字孪生档案，支持长期健康状态跟踪与科学养护规划。 </div>" +
              " <div class='content-item'>（三）多技术融合：结合红外热成像检测内部缺陷，扫描辅助变形分析，提升综合检测能力。</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm4.png' alt=''></div>"
        },
        {
          title:'道路智能检测与数字化运维方案',
          info:'为全面提升道路养护的精准性和效率，本方案采用无人机巡航检测系统搭配自动巡检机器人检测设备相结合的方式，构建空-地一体化的智能检测体系，并依托大数据分析、三维重建及AI病害识别技术，实现道路全生命周期的数字化运维管理。',
          url:'/static/img6.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）无人机巡航检测系统：搭载高清摄像头，无人机可高效采集道路路面、边坡、交安设施等的高分辨率影像及三维点云数据，快速覆盖大面积路网，尤其适用于山区、高架桥等人工检测困难区域。</div>" +
              " <div class='content-item'>（二）道路激光车检测设备 ：采用高精度激光扫描，实时获取路面平整度、车辙、裂缝等数据，结合GPS定位生成道路几何线形与病害分布图，满足自动化、高频率巡检需求。</div>" +
              " <div class='content-item'>（三）多源数据融合与三维重建：通过三维建模技术，将无人机影像、激光点云等多源异构数据融合，构建道路数字孪生模型，支持全要素可视化展示与分析。 </div>" +
              " <div class='content-item'>（四）AI病害智能识别：基于深度学习的图像处理算法，自动识别裂缝、坑槽、松散等典型病害，并依据规范进行损伤等级评定，输出结构化报告。 </div>" +
              " <div class='content-item'>（五）大数据分析与预测：依托数据仓库，整合历史检测数据与交通荷载信息，建立道路性能退化模型，预测病害发展趋势，优化养护决策。</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）高效覆盖：无人机与激光车协同作业，检测效率较传统人工大幅提升。</div>" +
              " <div class='content-item'>（二）精准诊断：多维度数据交叉验证，提高病害识别准确率。</div>" +
              " <div class='content-item'>（三）全周期管理：从检测到养护闭环管理，延长道路使用寿命，降低运维成本。</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm5.png' alt=''></div>"
        },
        {
          title:'隧道智能施工监测与安全预警系统方案',
          info:'本方案采用隧道巡检机器人，结合物联网传感网络、AI视觉分析及三维数字建模技术，构建集实时监测、风险预警与决策支持于一体的智能管控平台，保障隧道施工安全高效推进。',
          url:'/static/img7.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）隧道智能巡检机器人：搭载高清摄像头等设备，机器人可自主巡航或远程操控，实时采集隧道关键部位的图像、变形数据及环境参数；适应复杂施工环境，替代人工完成高风险区域检测。</div>" +
              " <div class='content-item'>（二）多参数协同监测网络：布设位移传感器、应力计等物联网设备，实时监测支护结构受力等变化，数据无线传输至云端平台，实现施工状态全维度感知。</div>" +
              " <div class='content-item'>（三）AI视觉病害识别：通过深度学习算法，自动识别裂缝、渗水、岩体剥落等病害，并评估其危险等级，触发分级预警。 </div>" +
              " <div class='content-item'>（四）三维实景建模：基于机器人采集的点云数据，构建隧道施工进度与结构状态的数字孪生模型，支持虚拟巡检与变形趋势分析。</div>" +
              " <div class='content-item'>（五）风险动态预测：融合地质雷达数据与施工参数，利用大数据分析预测塌方、突水等风险，提供防控措施建议。</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）无人化作业：机器人替代人工进入高危区域，降低安全风险。</div>" +
              " <div class='content-item'>（二）高精度监测：毫米级变形识别与多传感器数据融合，提升监测可靠性。</div>" +
              " <div class='content-item'>（三）闭环管理：从数据采集到风险处置的全流程数字化，助力施工科学决策。</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm6.png' alt=''></div>"
        },
        {
          title:'道桥工程检测监测方案',
          info:'本方案采用多传感器融合及无人机检测等手段，针对道路和桥梁的状态进行监测。',
          url:'/static/img8.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）多源传感器网络实时监测：实时采集桥梁/道路的应力、应变、振动频率、位移等关键参数,实现对结构健康状态的监测。</div>" +
              " <div class='content-item'>（二）无人机智能巡检系统：搭载高清摄像头、红外热像仪、激光雷达，快速识别路面裂缝、桥面铺装破损、结构表面剥落等可见缺陷。</div>" +
              " <div class='content-item'>（三）数据分析与智能预警：整合传感器数据、无人机影像、InSAR（卫星雷达干涉）形变数据，构建多维度数据库；自动生成维修优先级建议，优化养护资源配置。 </div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）全周期覆盖，精准高效：传感器网络24/7连续监测。</div>" +
              " <div class='content-item'>（二）高精度与多维度融合：激光雷达与摄影测量技术结合，多源数据（传感器+无人机+卫星）交叉验证。</div>" +
              " <div class='content-item'>（三）智能决策支持：深度学习算法自动识别病害类型，基于GIS/BIM的可视化平台，支持病害定位、历史追溯与方案模拟。</div>" +
              " <div class='content-item'>（四）成本与安全优势：减少高空车、封闭交通等高成本作业，无人机替代高危区域人工巡检，规避人员坠落风险。</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm7.png' alt=''></div>"
        },
        {
          title:'矿山工程检测监测方案',
          info:'本方案设计了一套集智能监测、实时预警与水源识别于一体的矿井水文地质监测预报预警平台。该系统依托物联网、大数据分析和人工智能技术，对地下水水位、水压、水质、视频监控、水仓流量等关键参数进行全天候动态监测，构建矿山全生命周期的智能化水文管理体系。\n',
          url:'/static/img9.png',
          content: "<div class='con-title'>核心功能</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）多参数智能监测：通过高精度传感器网络，实时采集地下水动态数据（水位、水压）、水质指标、关键区域视频影像及水仓流量信息，形成综合数据库，为分析决策提供数据支撑。</div>" +
              " <div class='content-item'>（二）突水水源快速识别：针对矿山突水事故中危害性显著的第四系松散层潜水和海水入侵，系统通过水质特征比对与机器学习算法，实现水源类型的秒级判定，为应急响应争取宝贵时间。</div>" +
              " <div class='content-item'>（三）基于阈值判定与趋势预测模型，平台可自动触发分级预警,并通过短信、APP推送等方式通知管理人员，确保风险早发现、早处置。</div>" +
              " <div class='content-item'>（四）全生命周期管理：从矿山建设到闭坑阶段，平台持续积累水文地质数据，生成动态评价报告，辅助优化防治水工程设计，提升长期安全运营能力。</div>" +
              "</div>"+
              "<div class='con-title'>技术优势</div>" +
              "<div class='content'>" +
              " <div class='content-item'>（一）智能化分析：利用AI算法实现数据异常检测与突水概率预测，降低人为误判风险。</div>" +
              " <div class='content-item'>（二）可视化展示：通过三维地质模型与动态看板，直观呈现监测数据及风险分布。</div>" +
              "</div>" +
              "<div class='img-box'><img src='/static/product/algorithm8.png' alt=''></div>"
        }
      ]
    }
  },
  mounted() {
    // 页面加载时恢复滚动位置（如果是从详情页返回）
    this.$nextTick(() => {
      const scrollPosition = sessionStorage.getItem('schemeScrollPosition');
      if (scrollPosition) {
        window.scrollTo(0, parseInt(scrollPosition));
      }
    });
  },
  beforeRouteLeave(to, from, next) {
    // 如果是跳转到详情页，则保存滚动位置
    if (to.path === '/product') {
      sessionStorage.setItem('schemeScrollPosition', window.scrollY);
    }
    next();
  },
  methods:{
    goToInfo(item){
      // 保存当前滚动位置
      sessionStorage.setItem('schemeScrollPosition', window.scrollY);
      this.$router.push({
        path: '/product',
        query:{
          ...item
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.scheme-content{
  background: #131415;
}
.banner{
  height: 540px;
  background: url(../assets/images/scheme/banner.png) no-repeat center top;
  background-size:auto 100% ;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  .title{
    font-size: 52px;
  }
  .info{
    font-size: 16px;
    text-align: center;
    width: 100%;
    line-height: 32px;
    margin-top: 16px;
  }
}
.scheme-list{
  padding: 20px 20px 0;
  .item{
    margin-bottom: 22px;
    background: #242832;
    border-radius: 4px;
    min-height: 500px;
    height: 500px;
    color: #fff;
    text-align: center;
    padding: 40px 16px 20px;
    cursor: pointer;
    overflow: hidden;
    position: relative;
    .sub-title{
      font-size: 18px;
      line-height: 26px;
      margin-bottom: 12px;
    }
    .title{
      font-size: 22px;
      line-height: 32px;
    }
    .info{
      font-size: 14px;
      line-height: 24px;
      opacity: .6;
      padding: 8px 20px;
      margin-bottom: 24px;
    }
    .link{
      font-size: 14px;
      color: #3D91FF;
      margin-bottom: 20px;
    }
    img{
      max-width: 100%;
    }
    .el-image{
      width: 100%;
      height: auto;
      margin-top: 20px;
      transition: all .3s ease-in-out;
    }
    &:hover .el-image{
      transform: scale(1.05);
    }
  }
}

/* 大屏幕PC适配 */
@media screen and (min-width: 1600px) {
  .scheme-list .item {
    min-height: 550px;
    padding: 50px 24px 30px;
    .title {
      font-size: 24px;
    }
    .info {
      font-size: 15px;
      padding: 12px 30px;
    }
  }
}

/* 中屏幕PC适配 (1481-1599px) */
@media screen and (max-width: 1599px) and (min-width: 1481px) {
  .scheme-list .item {
    min-height: 520px;
    padding: 45px 20px 25px;
  }
}

/* 小屏幕PC适配 (1200-1480px) */
@media screen and (max-width: 1480px) and (min-width: 1200px) {
  .banner-text .info{
    font-size: 18px;
    line-height: 28px;
  }
  .scheme-list .item { 
      min-height: unset;
    }
  }

@media screen and (max-width: 1024px) and (min-width: 769px) {
  .banner .title{
    font-size: 42px;
  }
  .scheme-list{
    .item{
      min-height: 450px;
      padding: 30px 16px 16px;
      .title{
        font-size: 20px;
      }
      .info{
        padding: 8px 16px;
      }
    }
  }
}

/* 大屏平板适配 (1025-1199px) */
@media screen and (max-width: 1199px) and (min-width: 1025px) {
  .scheme-list .item {
    min-height: 460px;
    padding: 35px 18px 20px;
  }
}

@media screen and (max-width: 1480px){
  .banner-text .info{
    font-size: 18px;
    line-height: 28px;
  }
  .scheme-list {

    .item { 
      min-height: unset;
    }
  }
}

/* 移动端适配 */
@media screen and (max-width: 768px){
  .banner{
    height: 48vw;
    background: url(../assets/images/scheme/banner-mobile.png) no-repeat;
    background-size: 100% auto;
    padding-top: 30px;
    box-sizing: border-box;
    .title{
      font-size: 18px;
      line-height: 30px;
    }
    .info{
      font-size: 14px;
      padding: 0 16px;
      text-align: center;
    }
  }
  .scheme-list{
    padding: 20px 16px;
    .item{
      height: auto;
      min-height: unset;
      .title{
        font-size: 24px;
      }
      .el-image{
        position: static;
      }
    }
  }
}
</style>
